<template>
    <div>
        <base-crud
            :ref="'asksTable'"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :extra="extra"
            @edit="edit"
            @deleteRegister="deleteRegister"
            :dataForm="dataForm"
            :detailUrl="detailUrl"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                crudName: 'Perguntas',
                newText: 'Cadastrar Pergunta',
                table: 'asksTable',
                columns: ['id', 'title', 'dimension_id', 'type_id', 'actions'],
                tableData: ['id', 'title', 'dimension_id', 'type_id'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'title', 'dimension_id', 'type_id'],
                    filterable: ['id', 'title', 'dimension_id', 'type_id'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'title' : 'Título',
                        'dimension_id': 'Dimensão',
                        'type_id': 'Tipo',
                        'actions' : 'Ações'
                    },
                    templates: {
                        dimension_id(h, row, index) {
                            return row.dimension.name
                        },
                        type_id(h, row, index) {
                            return row.type.name
                        },
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = ['dimension', 'type'];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud edit",
                    title: "Editar",
                    name: "edit",
                    icon: "fas fa-pencil-alt"
                },
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud delete",
                    title: "Deletar",
                    name: "deleteRegister",
                    icon: "fas fa-trash-alt"
                },
            ],
                endPoint: 'researchasks/',
                detailUrl: 'ask',
                dataForm: {}
            }
        },
        methods: {
            edit(props){
            if(props.row.edit){
                this.$router.push('ask/' + props.row.id)
            }else {
                swal('Ops!', 'O registro não pode ser editado, pois já está vinculado a outra pesquisa!', 'info');
            }
            
            },
            deleteRegister(props){
            if(props.row.edit){
                const self = this
                

                swal({
                    title: "Deseja deletar o registro?",
                    text: "Essa operação não pode ser desfeita",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Sim, deletar!",
                    showLoaderOnConfirm: true,
                    buttons: {
                        catch: {
                            text: "Não",
                            value: "cancel",
                            className: "btn-danger"
                        },
                        confirm: {
                            text: "Sim",
                            value: 'confirm'
                        }
                    },
                })
                    .then((value) => {
                        switch (value) {
                            case 'cancel':
                                swal('Cancelado', 'O registro não foi excluido!', 'info');
                                break;

                            case 'confirm':

                                self.$http.delete(self.$store.state.api + 'researchasks/' + props.row.id, {
                                    'id': props.row.id
                                })
                                    .then((response) => {
                                        self.$refs.asksTable.$refs.table.refresh();
                                        swal('Sucesso', 'Registro excluído com sucesso!', 'success');
                                    });
                                break;
                        }
                   })
            }else {
                swal('Ops!', 'O registro não pode ser deletado, pois já está vinculado a outra pesquisa!', 'info');
            }
            
            },
            query: function (query) {
                let columns = {
                    id: 'id',
                    title: 'title',
                    dimension_id: 'dimension[name]',
                    type_id: 'type[name]',
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
            },
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Ask/Crud.vue